// extracted by mini-css-extract-plugin
module.exports = {"buttonForm":"styles_buttonForm__1uT2x","buttonView":"styles_buttonView__31NMk","buttonBack":"styles_buttonBack__1ObVW"};